import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { NotFoundComponent } from "@shared/components/not-found/not-found.component";
import { PublicGuard } from "@modules/auth/public.guard";
import { ErrorPageComponent } from "@shared/components/error-page/error-page.component";
import { AuthGuard } from "@modules/auth/auth-guard";

const routes: Routes = [
  { path: "", redirectTo: "auth/login", pathMatch: "full" },
  {
    path: "dashboard",
    // canActivate: [AuthGuard], 
    loadChildren: () =>
      import("@modules/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
  },

  {
    path: "auth",
    canLoad: [PublicGuard],
    loadChildren: () =>
      import("@modules/auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: "page-not-found",
    component: NotFoundComponent,
  },
  {
    path: "error-page",
    component: ErrorPageComponent,
  },
  { path: "**", redirectTo: "auth/login", pathMatch: "full" }
]; 

@NgModule({
  //imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  imports: [[RouterModule.forRoot(routes, {
    useHash: true,
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled'
  })],
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
